Ext.define('SA.view.Toolbar', {
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-toolbar',

    initComponent() {
        this.callParent();

        this.exportBtn = this.down('pvt-export-button');
    },

    initEvents() {
        this.callParent();

        if (this.exportBtn) {
            this.exportBtn.on('activate', this.onActivateExportBtn, this);
        }
    },

    onActivateExportBtn() {
        this.fireEvent('activate:exportBtn', this.exportBtn);
    }
});